module.exports = "<ama-cpp-general-coverages update-coverages=\"updateCoverages\">\r\n\r\n</ama-cpp-general-coverages>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/quoteandbind/ama/cpp/views/cpp-general-coverages.html
// module id = 471
// module chunks = 0